import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lessonStructureSelect", "studentObservationRoleSetting", "studentObservationRoleInput"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasLessonStructureSelectTarget || !this.hasStudentObservationRoleSettingTarget || !this.hasStudentObservationRoleInputTarget) return

    const isSingleStructure = this.lessonStructureSelectTarget.value === "single"
    this.studentObservationRoleSettingTarget.classList.toggle("u-hidden", !isSingleStructure)
    this.studentObservationRoleInputTarget.disabled = !isSingleStructure

    if (!isSingleStructure) {
      this.studentObservationRoleInputTarget.checked = false
    }
  }
}
